import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/billing/stripe-refresh"
)({
  beforeLoad: () => {
    throw redirect({
      to: "/organization-settings/billing/stripe-refresh",
      replace: true,
    })
  },
})
